<template>
 <div class="chat-contact-form-message chat-bubble agent">
    <ContactForm type="message" :messageId="messageId" :isSubmitted="isSubmitted"  @chatFormMessageSubmit="$emit('submit', {})"/>
  </div>
</template>

<script>
import ContactForm from 'widget/components/PreChat/ContactForm';
export default {
  components: { ContactForm },
  props: {
    messageId: {
      type: Number
    },
    isSubmitted: {
      type: Boolean
    }
  }
};
</script>


<style>
.chat-contact-form-message textarea {
    min-height: 34.5px;
    height: 38px;
}

.chat-contact-form-message.chat-bubble {
    margin: 0.25rem 0;
}

.chat-contact-form-message .font-medium {
    font-size: 14px;
}
</style>
